import "core-js/modules/es.array.concat.js";
import { service } from './service'; // 获取下游送货单List

export function LoadData(data) {
  return service({
    url: 'SubDeliveryNote/LoadData',
    data: data,
    method: 'post'
  });
} // 查询ERP采购订单明细数据

export function GetErpPoList(query) {
  return service({
    url: 'ScmErpPo/GetErpPo2Sub',
    method: 'get',
    params: query
  });
} // 保存送货单

export function saveOrderInfo(data) {
  return service({
    url: 'SubDeliveryNote/SaveData',
    data: data,
    method: 'post'
  });
} // 获取送货单明细

export function GetDetailList(query) {
  return service({
    url: 'SubDeliveryNote/GetDetailList',
    params: query,
    method: 'get'
  });
} // 审核送货单

export function AuditOrder(data) {
  return service({
    url: 'SubDeliveryNote/CheckBill',
    method: 'post',
    data: data
  });
} // 反审核

export function UnCheckBillOrder(data) {
  return service({
    url: 'SubDeliveryNote/UnCheckBill',
    method: 'post',
    data: data
  });
} // 作废

export function CancelBill(data) {
  return service({
    url: 'SubDeliveryNote/CancelBill',
    method: 'post',
    data: data
  });
} // 导出送货单list
// export function ExportListData ({ ORGANIZE_ID }) {
//   return service({
//     url: `SubDeliveryNote/ExportListData?Data.ORGANIZE_ID=${ORGANIZE_ID}`,
//     method: 'post'
//   })
// }

export function ExportListData(data) {
  return service({
    url: 'SubDeliveryNote/ExportListData',
    method: 'post',
    data: data
  });
} // 状态转在途

export function PrintBill(data) {
  return service({
    url: 'SubDeliveryNote/PrintBill',
    method: 'post',
    data: data
  });
} // 导出送货单明细

export function ExportDetailData(_ref) {
  var ID = _ref.ID,
      ORGANIZE_ID = _ref.ORGANIZE_ID,
      EXPORT_FILE_NAME = _ref.EXPORT_FILE_NAME;
  return service({
    url: "SubDeliveryNote/ExportDetailData?MST_ID=".concat(ID, "&ORGANIZE_ID=").concat(ORGANIZE_ID, "&EXPORT_FILE_NAME=").concat(EXPORT_FILE_NAME),
    method: 'get'
  });
} // 下一张

export function GetLastById(params) {
  return service({
    url: 'SubDeliveryNote/GetLastById',
    method: 'get',
    params: params
  });
} // 上一张

export function GetNextById(params) {
  return service({
    url: 'SubDeliveryNote/GetNextById',
    method: 'get',
    params: params
  });
} // 获取供应商列表

export function GetImsVendorLoadData(query) {
  return service({
    url: 'ImsVendor/LoadData',
    params: query,
    method: 'get'
  });
} // 获取送货单供应商邮箱

export function GetVendorEmail(params) {
  return service({
    url: 'SubDeliveryNote/GetVendorEmail',
    method: 'get',
    params: params
  });
}